module.exports = __webpack_public_path__ + "static/img/Popup@2x.a95a715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/Popup@2x.png
// module id = 7ipO
// module chunks = 70